export default "__VITE_ASSET__C7KKrKD8__"